<template>
<w-settings-summary ref="settingsSummary" :menu="menu" @change="onChangeMenu">
  <component slot="activeView" :is="activeView" :title="activeMenu.name"></component>
</w-settings-summary>
</template>

<script>
import filter from 'lodash/filter';
import WSettingsSummary from '@/components/template/SettingsSummary';
import WCollectionSettings from './CollectionSettings';
import WEventAlarmSettings from './EventAlarmSettings';
import WBasicInfoSettings from './BasicInfoSettings';
import WHealthCheck from './HealthCheck';
import WImageSettings from './ImageSettings';
import WScheduleSettings from './ScheduleSettings';
import WThirdPartySettings from './ThirdPartySettings';

export default {
  name: 'WOperationSettings',
  components: {
    WSettingsSummary,
    WCollectionSettings,
    WEventAlarmSettings,
    WBasicInfoSettings,
    WHealthCheck,
    WImageSettings,
    WScheduleSettings,
    WThirdPartySettings,
  },
  data() {
    return {
      activeMenu: {},
      activeView: null,
      menu: [
        {
          id: 'collectionSettings',
          name: '수집 설정',
          desc: ['관리 대상을 수집하는 수집서버와 자원별 수집 주기, 관리대상 중요도 별 스냅샷 주기와 데이터 보유기간, SNMP TRAP, SYSLOG, 어플리케이션에 대한 수집 포트를 설정 합니다.'],
          data: null,
          orderbyIndex: 1,
        },
        {
          id: 'eventAlarmSettings',
          name: '이벤트/알람',
          desc: ['각 자원별 이벤트 메시지와 공통 이벤트 등급을 설정하는 이벤트 부분과 E-Mail, 문자, 팝업 연계설정 및 알람 전송 결과를 확인 할 수 있습니다.'],
          data: null,
          orderbyIndex: 2,
        },
        {
          id: 'basicInfoSettings',
          name: '기준 정보 편집',
          desc: ['자원의 수집 및 이벤트 판단주기와 이벤트 임계치 및 알람 발생 설정, IP와 TCP/UDP 포트에 대한 별칭에 대한 기준정보를 설정 할 수 있습니다.'],
          data: null,
          orderbyIndex: 3,
        },
        // TODO: 2018.12.04 Ju 현재 백도어로 명령어를 수행하므로 보안상 이슈가 있어 기능 자체를 제공하지 않도록 숨김. 추후 APM팀에서 에이전트 개선 후 제공.
        // 2019. 10. 22 Song - SK하이닉스 POC - 서버 Agent 헬스 체크 개발건 진행
        {
          id: 'healthCheck',
          name: 'WatchAll 헬스 체크',
          desc: ['WatchAll 서버의 수집상태, 데이터 처리 상태, UI 표현 상태, 수집 Agent에 대한 상태의 정보를 확인 할 수 있습니다.'],
          data: null,
          orderbyIndex: 4,
        },
        {
          id: 'scheduleSettings',
          name: '스케줄 설정',
          desc: ['관리대상 종류 별 구성정보 수집과 스크립트 수행과 관련된 스케줄을 설정 할 수 있습니다.'],
          data: null,
          orderbyIndex: 5,
        },
        {
          id: 'thirdPartySettings',
          name: '타 제품 연동',
          desc: ['WatchAll에 연동하기 위한 타제품의 관리대상을 설정 할 수 있습니다.'],
          // desc: ['WatchAll에 연동하기 위한 타제품의 관리대상, 자원, 이벤트/알람등을 설정 할 수 있습니다.'],
          data: null,
          orderbyIndex: 6,
        },
        {
          id: 'imageSettings',
          name: '이미지 등록',
          desc: ['토폴로지맵에서 사용되는 이미지를 편집하거나 다운로드/업로드 할 수 있습니다.'],
          data: null,
          orderbyIndex: 7,
        },
      ],
    };
  },
  created() {
    // 서버, 네트워크, 데이터베이스가 활성화된 경우에만 스케쥴 설정 메뉴 제공
    const activeManagetypeIds = this.$store.getters.activeManagetypeIds;
    let menu = this.menu;
    if (activeManagetypeIds.indexOf('NMS') < 0 && activeManagetypeIds.indexOf('SMS') < 0 && activeManagetypeIds.indexOf('DBMS') < 0) {
      menu = filter(menu, (item) => item.id !== 'scheduleSettings');
    }

    if (activeManagetypeIds.indexOf('EMS') < 0) {
      menu = filter(menu, (item) => item.id !== 'thirdPartySettings');
    }
    this.menu = menu;
    // this.loadData();
  },
  methods: {
    onChangeMenu(activeView, activeMenu) {
      this.activeView = activeView;
      this.activeMenu = activeMenu;
    },
    clearActiveView() {
      this.$refs.settingsSummary.clearActiveView();
      // this.loadData();
    },
    // loadData() {
    // const dummyData = {
    //   deviceCount: 25,
    //   uncheckedDeviceCount: 25,
    //   userCount: 10,
    //   operStatus: '정상',
    // };
    //
    // const deviceRegistrationData = [];
    // const userAndAuthManagementData = [];
    // const operationSettingsData = [];
    //
    // deviceRegistrationData.push(`현재 관리 중인 장비 수는 <em>${getValueAfterCheckEmpty(dummyData.deviceCount)}대</em> 입니다.`);
    // deviceRegistrationData.push(`현재 미확인된 신규 장비 등록 대수는 <em>${getValueAfterCheckEmpty(dummyData.uncheckedDeviceCount)}대</em> 입니다.`);
    // userAndAuthManagementData.push(`현재 등록된 사용자는 총 <em>${getValueAfterCheckEmpty(dummyData.userCount)}명</em> 입니다.`);
    // operationSettingsData.push(`현재 WatchAll 운영 상태는 <em>${getValueAfterCheckEmpty(dummyData.operStatus)}</em> 입니다.`);
    //
    // const deviceRegistrationIndex = findIndex(this.menu, (item) => item.id === 'deviceRegistration');
    // this.menu[deviceRegistrationIndex].data = deviceRegistrationData;
    //
    // const userAndAuthManagementIndex = findIndex(this.menu, (item) => item.id === 'userAndAuthManagement');
    // this.menu[userAndAuthManagementIndex].data = userAndAuthManagementData;
    //
    // const operationSettingsIndex = findIndex(this.menu, (item) => item.id === 'operationSettings');
    // this.menu[operationSettingsIndex].data = operationSettingsData;
    // },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/index.vue